import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Booking, getDatesInRange, monthNames } from '../utils/heatmapUtils';
import { HeatmapCell, HeatmapLegend, MonthRow } from './HeatmapComponents';

const BookingHeatmap = ({
    bookings,
    year,
}: {
    bookings: Booking[];
    year: number;
}) => {
    const bookingsByDate: { [date: string]: number } = {};

    for (const booking of bookings) {
        const dates = getDatesInRange(booking.checkin, booking.checkout);
        for (const date of dates) {
            bookingsByDate[date] = (bookingsByDate[date] || 0) + 1;
        }
    }

    const maxCount = Math.max(...Object.values(bookingsByDate), 1);

    const monthsData = monthNames.map((monthName, monthIndex) => {
        const daysInMonth = new Date(
            Date.UTC(year, monthIndex + 1, 0)
        ).getUTCDate();
        const days = [];

        for (let day = 1; day <= daysInMonth; day++) {
            const dateStr = `${year}-${String(monthIndex + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
            const count = bookingsByDate[dateStr] || 0;
            days.push({ day, date: dateStr, count });
        }

        return { month: monthName, days };
    });

    return (
        <Box display="flex" flexDirection="column" gap={3}>
            <Typography variant="h5">{year} Booking Heatmap</Typography>
            <Box display="flex" flexDirection="column" gap={2}>
                {monthsData.map(({ month, days }) => (
                    <MonthRow key={month} monthName={month}>
                        {days.map(({ date, count }) => (
                            <HeatmapCell
                                key={date}
                                count={count}
                                maxCount={maxCount}
                                tooltipTitle={`${date}: ${count} booking${count !== 1 ? 's' : ''}`}
                                size={12}
                            />
                        ))}
                    </MonthRow>
                ))}
            </Box>
            <HeatmapLegend maxCount={maxCount} size={12} />
        </Box>
    );
};

export default BookingHeatmap;
